module.exports = __webpack_public_path__ + "static/media/freshworks.3772fb25.png";